import { Accordion, AccordionSummary, AccordionDetails, Box, Typography, Link} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import OtherReportsTable from './OtherReportsTable';


const PaCommittee = (): JSX.Element => {

    return (

        <Box>
            <Typography variant="h6" gutterBottom fontWeight={600}>
                Political Action Committees
            </Typography>
            <Typography variant="body1" component={'p'} gutterBottom>
                Federal or out-of-state PACs that wish to support or oppose Massachusetts candidates must organize a separate Massachusetts PAC with OCPF (click <Link underline="none" href="https://www.ocpfreporter.us/OnlineOrganization/" target="_blank">here</Link> to register). Once organized, the Massachusetts PAC must ensure that all of its fundraising activities comply with the Massachusetts campaign finance law. Funds raised must be kept in a separate bank account established for the Massachusetts PAC. No transfers may be made from the Federal PAC or out-of-state PAC to the Massachusetts PAC.
            </Typography>

            <Accordion defaultExpanded>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="subtitle1" marginBottom={1}><b>Report Filing Schedules</b></Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <OtherReportsTable isPac={true} />
                </AccordionDetails>
            </Accordion>


        </Box >
    )
};

export default PaCommittee;